import { IRegionShort } from '@/api/region/types';
import { OuterPlanYourTripPropsType } from './types';
import { PlanYourTrip } from './Component';
import { hasWeSkiIntegration, weSkiDestinationId } from './WeSki/resolver';

interface IRegionPlanYourTripProps extends OuterPlanYourTripPropsType {
  region: IRegionShort,
  templateName?:string;
}

const PlanYourTripRegionWrapper = ({
  region,
  templateName,
  ...props
}: IRegionPlanYourTripProps) => {
  const redirectSkiRentalPath = '';
  const { title } = region;

  // Only WeSki lodging is available after the TripAdvisor retirement.
  const hasWeSki = hasWeSkiIntegration({ regionId: region.uuid });
  const lodgingProvider = hasWeSki ? 'weski' : undefined;
  const weDestinationId = hasWeSki ? weSkiDestinationId({ regionId: region.uuid }) : null;

  return (
    <PlanYourTrip
      {...props}
      contextKey="region"
      title={title}
      redirectSkiRentalPath={redirectSkiRentalPath}
      lodgingProvider={lodgingProvider}
      weSkiDestinationId={weDestinationId}
      templateName={templateName}
      regionId={region.uuid}
    />
  );
};

export default PlanYourTripRegionWrapper;
